// extracted by mini-css-extract-plugin
export default {"layout":"_5D3ShLyL","content":"_5D13AjWR"};